class ComplementaryVariantPicker extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('form');

    this.product = JSON.parse(this.querySelector('[data-product]')?.innerHTML);
    this.productFormId = this.getAttribute('data-form-id');
    this.formVariantIdInput = document.querySelector(`#${this.productFormId} input[name="id"]`);
  }

  connectedCallback() {
    this.form?.addEventListener('change', this.onChange.bind(this));
  }

  onChange() {
    const formData = new FormData(this.form);
    let options = [];

    for (const [key, value] of formData) {
      options.push(value)
    }

    this.variant = this.product.variants.find(variant => {
      if (JSON.stringify(variant.options) === JSON.stringify(options)) return variant;
    })

    this.formVariantIdInput.value = this.variant.id;
  }
}

if (!customElements.get('complementary-variant-picker')) {
  customElements.define('complementary-variant-picker', ComplementaryVariantPicker);
}